// extracted by mini-css-extract-plugin
export default {"database_overview":"DatabaseOverviewWidget_database_overview__z3iWb","dark":"DatabaseOverviewWidget_dark__8AlJS"};